<template>
  <v-card>
    <v-form @submit="submit" onSubmit="return false;">
      <v-card-title class="headline">
        Фильтр
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="$emit('close-dialog')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4><v-text-field label="Фамилия" v-model="filter.last_name" clearable></v-text-field></v-flex>
            <v-flex xs12 sm6 md4><v-text-field label="Имя" v-model="filter.first_name" clearable></v-text-field></v-flex>
            <v-flex xs12 sm6 md4><v-text-field label="Отчество" v-model="filter.middle_name" clearable></v-text-field></v-flex>
            <v-flex xs12><v-text-field label="ID" v-model="filter.uuid" clearable></v-text-field></v-flex>
            <v-flex xs12 sm6><v-text-field label="Email" v-model="filter.email" clearable></v-text-field></v-flex>
            <v-flex xs12 sm6><v-text-field label="Телефон" v-model="filter.phone" clearable></v-text-field></v-flex>
          </v-layout>
        </v-container>
        
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn class="info" type="submit">Поиск</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  export default {
    name : "UserFilterForm",
    
    props: {
      data: {
        type: Object,
        required: false,
        default: () => ({
          last_name: '',
          first_name: '',
          middle_name: '',
          uuid: '',
          email: '',
          phone: ''
        })
      }
    },
    
    data: () => ({
      filter: {}
    }),
    
    created(){
      this.filter = JSON.parse(JSON.stringify(this.data))
    },
    
    methods:{
      submit(){
        this.$emit('save', {type: 'filter', data: this.filter})
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/accounts/components/Forms/UserFilterForm.vue